import { FIXED_MEMBERSHIP, HOURLY_MEMBERSHIP, HYBRID_MEMBERSHIP, PERCENTAGE_MEMBERSHIP, REDEEMABLES_TYPES } from "@constant/common";
import { MembershipIcon } from "@element/icons";
import RedeemableItemModal from "@module/reedemablesListView/redeemableItemModal";
import { resolveBaseRouteUrl } from "@util/routerService";
import { getCurrencySymbol, getTofixValue } from "@util/utils";
import { useRouter } from "next/router";
import { useState } from "react";
import { useSelector } from "react-redux";

function RedeemablesListView({ type, fromPage, userData, setShowUserRegistrationModal }) {
    const router = useRouter();
    const redeemablesList = useSelector((state: any) => state.redeemablesList);
    const [selectedItem, setSelectedItem] = useState(null)
    const currentTypeList = redeemablesList ? redeemablesList[type] : []
    const cardColors = ['#787cff', '#85efc0', '#fdb3b3', '#fcd296'];
    const isMembership = type == REDEEMABLES_TYPES.MEMBERSHIPS;
    const isPackage = type == REDEEMABLES_TYPES.PACKAGES;
    const isGiftCard = type == REDEEMABLES_TYPES.GIFTCARDS;
    const title = isMembership ? "Membership Plans" : isPackage ? "Packages" : "Gift Cards";


    const onClickItem = (item: any, type: any) => {
        if (Boolean(fromPage) && !userData) {
            setShowUserRegistrationModal(true);
        } else {
            setSelectedItem(item)
        }
    }


    const onClickView = (type: any) => {
        if (!userData) {
            setShowUserRegistrationModal(true);
        } else {
            const baseRouteUrl = resolveBaseRouteUrl();
            router.push({ pathname: `${baseRouteUrl}purchase/${type}` }, undefined, { scroll: true, shallow: true });
        }
    }

    return (
        <>

            {Boolean(currentTypeList?.length) && <div className="section-container container-padd">
                <div className="section-header">
                    <h2 className="title cap-text">{title}</h2>
                </div>

                <div className="card-grid">
                    {(Boolean(fromPage) ? currentTypeList.slice(0, 4) : currentTypeList).map((item, index) => {
                        const barColor = cardColors[index % cardColors.length];

                        let displayPrice = 0;
                        if (isMembership) displayPrice = item.membershipFee;
                        else if (isPackage) displayPrice = item.price;
                        else if (isGiftCard) displayPrice = item.giftCardValue;

                        return (
                            <div
                                key={index}
                                className={`common-card-ui ${type}-card`}
                                onClick={() => onClickItem(item, type)}
                            >
                                <div className="header-row">
                                    {!isMembership && (
                                        <div
                                            className="status-bar"
                                            style={{ backgroundColor: barColor }}
                                        ></div>
                                    )}

                                    <div className="header-content">
                                        {isMembership ? (
                                            <div className="icon-badge" style={{ color: barColor, backgroundColor: `${barColor}60` }}>
                                                <MembershipIcon className="membership" idPrefix={`membership-${item.id || item._id || index}`} />
                                            </div>
                                        ) : (
                                            <h3 className="display-name">{item.name}</h3>
                                        )}
                                        <div className="arrow-circle">&rarr;</div>
                                    </div>
                                </div>

                                <div className="body-content">
                                    {isMembership && <h3 className="display-name">{item.name}</h3>}

                                    <div className="label-row">
                                        Fee: {getCurrencySymbol()} {getTofixValue(Number(displayPrice))}
                                    </div>
                                    <div className="label-row">Validity: {item.validity} Days</div>

                                    {isMembership && (
                                        <>
                                            {item.typeId == HOURLY_MEMBERSHIP && (
                                                <div className="label-row">Hours: {item.totalMinutes / 60} Hrs</div>
                                            )}
                                            {item.typeId == FIXED_MEMBERSHIP && (
                                                <div className="label-row">Benefit Amount: {getCurrencySymbol()}{item.benefit}</div>
                                            )}
                                            {Boolean(!item.isSpecificDays) && (item.typeId == PERCENTAGE_MEMBERSHIP || item.typeId == HYBRID_MEMBERSHIP) && (
                                                <div className="label-row">Std Discount: {item.discount}%</div>
                                            )}
                                        </>
                                    )}

                                    {isPackage && (
                                        <>
                                            {item.packagesTypeId == 2 && <div className="label-row">Item Quantity: {item.itemsBaseQuantity || 0}</div>}
                                            <div className="services-preview">
                                                <div className="services-title">
                                                    <span>Services</span>
                                                    <span className="qty-count" style={{ color: barColor, fontWeight: 'bolder' }}>
                                                        {item.packageItems?.length || 0}
                                                    </span>
                                                </div>
                                                {item.packageItems?.slice(0, 3).map((pkgItem, i) => (
                                                    <div key={i} className="service-line">
                                                        <span>{pkgItem.itemName}</span>
                                                        <span>{pkgItem.quantity}</span>
                                                    </div>
                                                ))}
                                                {item.packageItems?.length > 3 && <span className="more-wrap"> See details...</span>}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>

                {Boolean(fromPage) && currentTypeList.length > 4 && (
                    <div className="pagination-bottom">
                        <button className="view-more-action" onClick={() => onClickView(type)}>View More &rarr;</button>
                    </div>
                )}
            </div>}
            {Boolean(selectedItem) && <RedeemableItemModal type={type} item={selectedItem} onClose={() => setSelectedItem(null)} />}
        </>
    )
}

export default RedeemablesListView
